import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../utlis/axiosInstance";
import moment from "moment";
import { format } from "date-fns";
import { useUser } from "../provider/UserProvider";
// import { useDevice } from "../provider/DeviceProvider";
import { toast } from "react-toastify";
import {
  generateLiveLocationUrl,
  LiveLocationData,
  getExpiryTimeMs,
  getRemainingMs,
} from "../utils/encryption";
import {
  GoogleMap,
  Marker,
  Circle,
  useJsApiLoader,
  TrafficLayer,
  InfoWindow,
  Polyline,
} from "@react-google-maps/api";
import {
  Box,
  Typography,
  Paper,
  IconButton,
  Fab,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress,
  TextField,
  InputAdornment,
  Snackbar,
  Tooltip,
  Chip,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  MyLocation as MyLocationIcon,
  Directions as DirectionsIcon,
  LocationOn as LocationOnIcon,
  LocalMall as LocalMallIcon,
  History as HistoryIcon,
  VpnKey as KeyIcon,
  Wifi as WifiIcon,
  Battery20 as BatteryIcon,
  Share as ShareIcon,
  Lock as LockIcon,
  AcUnit as AcIcon,
  LocalGasStation as FuelIcon,
  Person as DriverIcon,
  Thermostat as TempIcon,
  DoorSliding as DoorSlidingIcon,
  Power as PowerIcon,
  Speed as SpeedIcon,
  Timer as TimerIcon,
  Stop as StopIcon,
  Pause as PauseIcon,
  DirectionsCar as CarIcon,
  Menu as MenuIcon,
  Close as CloseIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Traffic as TrafficIcon,
  LocalParking as ParkingIcon,
  Map as MapIcon,
  Fence as FenceIcon,
  LocationSearching as LiveLocationIcon,
  ContentCopy as CopyIcon,
} from "@mui/icons-material";

// Google Maps configuration
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = {
  lat: 28.6139,
  lng: 77.209,
};

interface Device {
  id: number;
  name: string;
  unique_id: string;
  status: string;
  phone: string;
  model: string;
  category: string;
  expiration_time?: string | number;
  attributes: {
    ignition: boolean;
    charge: boolean;
    blocked: boolean;
    battery_level: string;
    status: string;
    device_online: boolean;
    latest_speed?: number;
    odometer?: number;
    ac?: boolean;
    port: any;
    mdn_number?: string;
    customer_name?: string;
    last_updated_at: any;
  };
  port?: {
    power?: boolean;
    ignition?: boolean;
    ac?: boolean;
    fuel?: boolean;
    temp?: boolean;
    door?: boolean;
    immobilizer?: boolean;
    internalBattery?: boolean;
    externalBattery?: boolean;
  };
  latest_position?: {
    gps_data: {
      latitude: number;
      longitude: number;
      address?: string; // <-- Add address field
      course_status?: {
        course?: number;
      };
      battery_power: any;
    };
    updated_at: number;
    protocol?: string;
  };
  latest_heartbeat?: {
    gps_data: {
      voltage_level: string;
      external_voltage_value?: number;
      terminal_info?: {
        oil_electricity_disconnected: boolean;
      };
      battery_power: any;
    };
    updated_at: number;
  };
}

interface Geofence {
  id: string;
  configId: string;
  name: string;
  latitude: number;
  longitude: number;
  radius: number;
  description?: string;
  zone_type?: string;
  alert_radius?: string;
}

interface ReportData {
  total_distance?: number;
  running_time?: string | number;
  idle_time?: string | number;
  stop_time?: string | number;
  ignition_hours?: string | number;
  inactive_time?: string | number;
}

const VehicleTracking: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { permissions } = useUser();
  console.log("permissions", permissions)
  const [devices, setDevices] = useState<any[]>([]); // Using local state instead of DeviceProvider
  // Google Maps API loader
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  // Permission checks
  const canControlEngine = permissions?.includes("ENGINE_CUT_OFF_ACCESS");
  const canControlMobilizer = permissions?.includes("MOBILIZER_ACCESS");
  const canControlParking = permissions?.includes("PARKING_ACCESS");
  const canControlAC = permissions?.includes("AC_ACCESS");
  const canControlFuel = permissions?.includes("FUEL_ACCESS");

  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<google.maps.Map | null>(null);
  const markerRef = useRef<google.maps.Marker | null>(null);
  const myLocationMarkerRef = useRef<google.maps.Marker | null>(null);
  const trafficLayerRef = useRef<google.maps.TrafficLayer | null>(null);

  // State
  const [device, setDevice] = useState<any | null>(null);
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [odometer, setOdometer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showTraffic, setShowTraffic] = useState(false);
  const [showParking, setShowParking] = useState(false);
  const [mapType, setMapType] = useState<
    "roadmap" | "satellite" | "terrain" | "hybrid"
  >("roadmap");
  const [mapTypeModalOpen, setMapTypeModalOpen] = useState(false);
  const [nearbyPlacesModalOpen, setNearbyPlacesModalOpen] = useState(false);
  const [isMapInitialized, setIsMapInitialized] = useState(false);
  const [showingMyLocation, setShowingMyLocation] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMarker, setSelectedMarker] = useState<string | null>(null);
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error" | "info" | "warning";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  // Geofence state
  const [showGeofenceModal, setShowGeofenceModal] = useState(false);
  const [geofences, setGeofences] = useState<Geofence[]>([]);
  const [isCreatingGeofence, setIsCreatingGeofence] = useState(false);
  const [isAddingGeofence, setIsAddingGeofence] = useState(false);
  const [isLoadingGeofences, setIsLoadingGeofences] = useState(false);
  const [geofencePreviewMarker, setGeofencePreviewMarker] =
    useState<google.maps.Marker | null>(null);
  const [newGeofence, setNewGeofence] = useState<{
    name: string;
    description: string;
    radius: number;
    zone_type: string;
    alert_radius: string;
    latitude: number;
    longitude: number;
  }>({
    name: "",
    description: "",
    radius: 100,
    zone_type: "restricted",
    alert_radius: "500m",
    latitude: 0,
    longitude: 0,
  });

  // Live location state
  const [showLiveLocationModal, setShowLiveLocationModal] = useState(false);
  const [selectedTimeInterval, setSelectedTimeInterval] = useState<number>(5);
  const [liveLocationUrl, setLiveLocationUrl] = useState<string>("");
  const [liveExpiryText, setLiveExpiryText] = useState<string>("");

  // Rotated icon for JSX Marker usage
  const [rotatedMarkerIcon, setRotatedMarkerIcon] =
    useState<google.maps.Icon | null>(null);

  // Back trail path for the device
  const [trailPath, setTrailPath] = useState<
    Array<{ lat: number; lng: number }>
  >([]);
  const MAX_TRAIL_POINTS = 500; // cap to avoid memory bloat

  // Initialize trail with current position on first load of valid coords
  useEffect(() => {
    const lat = Number(device?.latest_position?.gps_data?.latitude);
    const lng = Number(device?.latest_position?.gps_data?.longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      setTrailPath([]);
      return;
    }
    // Reset trail on device change and start with current position
    setTrailPath([{ lat, lng }]);
  }, [device?.id]);

  // Append to trail when position changes; skip duplicates
  useEffect(() => {
    const lat = Number(device?.latest_position?.gps_data?.latitude);
    const lng = Number(device?.latest_position?.gps_data?.longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    setTrailPath((prev) => {
      if (prev.length > 0) {
        const last = prev[prev.length - 1];
        if (last.lat === lat && last.lng === lng) return prev;
      }
      const next = [...prev, { lat, lng }];
      if (next.length > MAX_TRAIL_POINTS) {
        return next.slice(next.length - MAX_TRAIL_POINTS);
      }
      return next;
    });
  }, [
    device?.latest_position?.gps_data?.latitude,
    device?.latest_position?.gps_data?.longitude,
  ]);

  useEffect(() => {
    const updateIcon = async () => {
      if (!device?.latest_position?.gps_data) {
        setRotatedMarkerIcon(null);
        return;
      }
      const icon = await getRotatedIconForDevice(device, 32);
      setRotatedMarkerIcon(icon);
    };
    updateIcon();
  }, [
    device?.latest_position?.gps_data?.latitude,
    device?.latest_position?.gps_data?.longitude,
    device?.latest_position?.gps_data?.course_status?.course,
  ]);

  // Function to get current map center for geofence creation
  const getCurrentMapCenter = () => {
    if (mapInstanceRef.current) {
      const center = mapInstanceRef.current.getCenter();
      if (center) {
        return {
          latitude: center.lat(),
          longitude: center.lng(),
        };
      }
    }
    // Fallback to device position or default
    return currentMarkerPosition;
  };

  // Function to show geofence preview marker
  const showGeofencePreview = (position: {
    latitude: number;
    longitude: number;
  }) => {
    if (!mapInstanceRef.current) return;

    // Remove existing preview marker
    if (geofencePreviewMarker) {
      geofencePreviewMarker.setMap(null);
    }

    // Create new preview marker
    const marker = new google.maps.Marker({
      position: { lat: position.latitude, lng: position.longitude },
      map: mapInstanceRef.current,
      title: "Geofence Location",
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: "#FF0000",
        fillOpacity: 0.8,
        strokeColor: "#FF0000",
        strokeWeight: 2,
      },
    });

    setGeofencePreviewMarker(marker);
  };

  const [currentMarkerPosition, setCurrentMarkerPosition] = useState({
    latitude: Number(device?.latest_position?.gps_data?.latitude) || 0,
    longitude: Number(device?.latest_position?.gps_data?.longitude) || 0,
  });

  // Fetch device data
  const fetchDevice = useCallback(async (isInitialLoad = false) => {
    if (!id) return;

    // Only show loading if we don't already have device data or if explicitly requested
    if (isInitialLoad && !device) {
      setLoading(true);
    }
    setError(null);

    try {
      const response = await axiosInstance.get("/gpstracker/devicehandler/", {
        params: {
          limit: 10000,
          offset: 0,
        },
      });

      if (response.data?.responseData && Array.isArray(response.data.responseData)) {
        const allDevices = response.data.responseData;
        const filteredDevices = allDevices.filter((d: any) => !d.inventory && !d.disabled);
        setDevices(filteredDevices);

        const currentDevice = filteredDevices.find((d: any) => d.id === Number(id));
        if (currentDevice) {
          setDevice(currentDevice);
          setOdometer(currentDevice?.attributes?.odometer || 0);

          // Handle map updates based on whether device has location data
          if (mapInstanceRef.current) {
            if (currentDevice?.latest_position?.gps_data) {
              // Device has location data - update marker and map
              const { latitude, longitude } =
                currentDevice.latest_position.gps_data;
              const newPosition = {
                lat: Number(latitude),
                lng: Number(longitude),
              };

              // Update current marker position state
              setCurrentMarkerPosition({
                latitude: Number(latitude),
                longitude: Number(longitude),
              });

              const rotatedIcon = await getRotatedIconForDevice(
                currentDevice,
                32
              );
              if (markerRef.current) {
                // Update existing marker
                markerRef.current.setPosition(newPosition);
                markerRef.current.setIcon(rotatedIcon);
              } else {
                // Create new marker
                markerRef.current = new google.maps.Marker({
                  position: newPosition,
                  map: mapInstanceRef.current,
                  title: currentDevice.name,
                  icon: rotatedIcon,
                });
              }

              // Only center map on vehicle if not showing user's location
              if (!showingMyLocation) {
                mapInstanceRef.current.panTo(newPosition);
                // Only zoom if it's the very first success or if map isn't zoomed in
                if (isInitialLoad && mapInstanceRef.current.getZoom()! < 15) {
                  mapInstanceRef.current.setZoom(15);
                }
              }
            } else {
              // Device has no location data - hide marker and show default view
              if (markerRef.current) {
                markerRef.current.setMap(null);
                markerRef.current = null;
              }

              // Center map to a default location
              if (!showingMyLocation && isInitialLoad) {
                mapInstanceRef.current.panTo(defaultCenter);
                mapInstanceRef.current.setZoom(15);
              }
            }
          }
        }
      }
    } catch (err: any) {
      console.error("Device fetch error:", err);
      // Only set error if we don't have a device yet to avoid blocking background updates
      if (!device) {
        setError("Failed to load device data");
      }
    } finally {
      if (isInitialLoad) {
        setLoading(false);
      }
    }
  }, [id, device, showingMyLocation, isMapInitialized]); // Map Instance Ref is stable, no need to include

  // Fetch report data
  const fetchReportData = async () => {
    if (!id || !device?.id) return;

    try {
      const now = new Date();
      const yesterday = new Date(now);
      yesterday.setHours(0, 0, 0, 0);

      const endTime = new Date();

      // Match mobile app time calculation: subtract 5 hours 30 minutes (UTC to IST offset)
      const fromDateStr = moment(yesterday)
        .subtract(5, "hours")
        .subtract(30, "minutes")
        .format("YYYY-MM-DDTHH:mm:ss[Z]");

      const toDateStr = moment(endTime)
        .subtract(5, "hours")
        .subtract(30, "minutes")
        .format("YYYY-MM-DDTHH:mm:ss[Z]");

      const response = await axiosInstance.get(
        `/gpstracker/device/${device.id}/report?from=${encodeURIComponent(fromDateStr)}&to=${encodeURIComponent(toDateStr)}&report=summary`
      );

      if (response.data?.responseData) {
        const responseData = response.data.responseData;

        // Extract device data - structure: responseData[deviceId][date]
        const deviceIdStr = device.id.toString();
        const deviceData = responseData[deviceIdStr];

        if (deviceData) {
          // Get today's date in YYYY-MM-DD format
          const today = moment().format("YYYY-MM-DD");

          // Try to get today's data, otherwise get the most recent date
          let reportDataForDate = deviceData[today];

          if (!reportDataForDate) {
            // Get the most recent date
            const dates = Object.keys(deviceData).sort().reverse();
            if (dates.length > 0) {
              reportDataForDate = deviceData[dates[0]];
            }
          }

          if (reportDataForDate) {
            // Parse time strings to hours for display
            const parseTimeString = (timeStr: string): string => {
              if (!timeStr || typeof timeStr !== 'string') return "0h 0m";
              return timeStr; // Return as-is since it's already formatted
            };

            setReportData({
              total_distance: reportDataForDate.total_distance || 0,
              running_time: parseTimeString(reportDataForDate.running_time || "0h 0m 0s"),
              idle_time: parseTimeString(reportDataForDate.idle_time || "0h 0m 0s"),
              stop_time: parseTimeString(reportDataForDate.stop_time || "0h 0m 0s"),
              ignition_hours: parseTimeString(reportDataForDate.ignition_hours || "0h 0m 0s"),
              inactive_time: parseTimeString(reportDataForDate.inactive_time || "0h 0m 0s"),
            });
          } else {
            // No data available, set defaults
            setReportData({
              total_distance: 0,
              running_time: "0h 0m 0s",
              idle_time: "0h 0m 0s",
              stop_time: "0h 0m 0s",
              ignition_hours: "0h 0m 0s",
              inactive_time: "0h 0m 0s",
            });
          }
        } else {
          // No device data found
          setReportData({
            total_distance: 0,
            running_time: "0h 0m 0s",
            idle_time: "0h 0m 0s",
            stop_time: "0h 0m 0s",
            ignition_hours: "0h 0m 0s",
            inactive_time: "0h 0m 0s",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      // Set default values on error
      setReportData({
        total_distance: 0,
        running_time: "0h 0m 0s",
        idle_time: "0h 0m 0s",
        stop_time: "0h 0m 0s",
        ignition_hours: "0h 0m 0s",
        inactive_time: "0h 0m 0s",
      });
    }
  };

  // Map a non-car category to its status-based colored icon
  const getCategoryIcon = (category?: string, statusColor?: string): string => {
    const color = statusColor || "gray";

    switch (category) {
      case "Bus":
        switch (color) {
          case "green": return "/bus/bus-green.png";
          case "red": return "/bus/bus-red.png";
          case "yellow": return "/bus/bus-yellow.png";
          case "orange": return "/bus/bus-yellow.png"; // Support both yellow and orange
          case "blue": return "/bus/bus-blue.png";
          default: return "/bus/bus-gray.png";
        }
      case "Dog":
        switch (color) {
          case "green": return "/dog/dog-green.png";
          case "red": return "/dog/dog-red.png";
          case "yellow": return "/dog/dog-yellow.png";
          case "orange": return "/dog/dog-yellow.png"; // Support both yellow and orange
          case "blue": return "/dog/dog-blue.png";
          default: return "/dog/dog-gray.png";
        }
      case "Men":
        switch (color) {
          case "green": return "/men/men-green.png";
          case "red": return "/men/men-red.png";
          case "yellow": return "/men/men-yello.png";
          case "orange": return "/men/men-yello.png"; // Support both yellow and orange
          case "blue": return "/men/men-blue.png";
          default: return "/men/men-gray.png";
        }
      case "Swag":
        switch (color) {
          case "green": return "/swag/swag-green.png";
          case "red": return "/swag/swag-red.png";
          case "yellow": return "/swag/swag-yellow.png";
          case "orange": return "/swag/swag-yellow.png"; // Support both yellow and orange
          case "blue": return "/swag/swag-blue.png";
          default: return "/swag/swag-gray.png";
        }
      case "Tractor":
        switch (color) {
          case "green": return "/tractor/tractor-green.png";
          case "red": return "/tractor/tractor-red.png";
          case "yellow": return "/tractor/tractor-yellow.png";
          case "orange": return "/tractor/tractor-yellow.png"; // Support both yellow and orange
          case "blue": return "/tractor/tractor-blue.png";
          default: return "/tractor/tractor-gray.png";
        }
      case "TwoWheeler":
        switch (color) {
          case "green": return "/twoWheeler/twoWheeler-green.png";
          case "red": return "/twoWheeler/twoWheeler-red.png";
          case "yellow": return "/twoWheeler/twoWheeler-yellow.png";
          case "orange": return "/twoWheeler/twoWheeler-yellow.png"; // Support both yellow and orange
          case "blue": return "/twoWheeler/twoWheeler-blue.png";
          default: return "/twoWheeler/twoWheeler-gray.png";
        }
      case "Women":
        switch (color) {
          case "green": return "/women/women-green.png";
          case "red": return "/women/women-red.png";
          case "yellow": return "/women/women-yellow.png";
          case "orange": return "/women/women-yellow.png"; // Support both yellow and orange
          case "blue": return "/women/women-blue.png";
          default: return "/women/women-gray.png";
        }
      default:
        return "/car/white.png";
    }
  };

  // Get vehicle icon URL based on category and status
  const getVehicleIconUrl = (deviceData?: Device) => {
    const currentDevice = deviceData || device;
    if (!currentDevice) return "/car/white.png";

    const statusColor = getDeviceStatusColor(currentDevice);

    // Use category icon with status color if not a car
    if (currentDevice?.category && currentDevice?.category.toLowerCase() !== "car") {
      return getCategoryIcon(currentDevice?.category, statusColor);
    }

    // Car: use status-based colored car icons
    switch (statusColor) {
      case "blue": return "/car/blue.png";
      case "green": return "/car/green.png";
      case "yellow": return "/car/orange.png"; // Map yellow to orange for car icons
      case "red": return "/car/red.png";
      default: return "/car/white.png";
    }
  };

  // Get heading/course from latest position if available
  const getVehicleHeadingDegrees = (deviceData?: Device): number => {
    const currentDevice = deviceData || device;
    const course =
      currentDevice?.latest_position?.gps_data?.course_status?.course;
    if (typeof course === "number" && !Number.isNaN(course)) {
      const normalized = course % 360;
      return normalized < 0 ? normalized + 360 : normalized;
    }
    return 0;
  };

  // Cache for rotated icons to avoid re-rendering canvas for same url+angle+size
  const rotatedIconCacheRef = useRef<Map<string, google.maps.Icon>>(new Map());

  const createRotatedIconDataUrl = (
    imageUrl: string,
    angleDegrees: number,
    size: number
  ): Promise<string> => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const context = canvas.getContext("2d");
        if (!context) {
          reject(new Error("Failed to get 2D context for canvas"));
          return;
        }
        context.clearRect(0, 0, size, size);
        context.translate(size / 2, size / 2);
        context.rotate((angleDegrees * Math.PI) / 180);
        context.drawImage(image, -size / 2, -size / 2, size, size);
        resolve(canvas.toDataURL("image/png"));
      };
      image.onerror = reject;
      image.src = imageUrl;
    });
  };

  const getRotatedIconForDevice = async (
    deviceData?: Device,
    size: number = 32
  ): Promise<google.maps.Icon> => {
    const url = getVehicleIconUrl(deviceData);
    const angle = getVehicleHeadingDegrees(deviceData);
    const cacheKey = `${url}|${angle}|${size}`;
    const cached = rotatedIconCacheRef.current.get(cacheKey);
    if (cached) return cached;
    const dataUrl = await createRotatedIconDataUrl(url, angle, size);
    const icon: google.maps.Icon = {
      url: dataUrl,
      scaledSize: new google.maps.Size(size, size),
      anchor: new google.maps.Point(size / 2, size / 2),
    };
    rotatedIconCacheRef.current.set(cacheKey, icon);
    return icon;
  };

  // Load map when component mounts
  const loadMap = () => {
    if (isMapInitialized) return;
    // Map will be initialized by the MapContainer ref callback
  };

  // Handle traffic layer toggle
  useEffect(() => {
    if (!isMapInitialized || !mapInstanceRef.current) return;

    if (showTraffic) {
      if (!trafficLayerRef.current) {
        trafficLayerRef.current = new google.maps.TrafficLayer();
      }
      trafficLayerRef.current.setMap(mapInstanceRef.current);
    } else {
      if (trafficLayerRef.current) {
        trafficLayerRef.current.setMap(null);
      }
    }
  }, [showTraffic, isMapInitialized]);

  // Handle map type changes
  useEffect(() => {
    if (isMapInitialized && mapInstanceRef.current) {
      // For Google Maps, we can switch between different map types
      const mapTypes = {
        roadmap: google.maps.MapTypeId.ROADMAP,
        satellite: google.maps.MapTypeId.SATELLITE,
        terrain: google.maps.MapTypeId.TERRAIN,
        hybrid: google.maps.MapTypeId.HYBRID,
      };

      mapInstanceRef.current.setMapTypeId(mapTypes[mapType]);
    }
  }, [mapType, isMapInitialized]);

  // Update map when device data changes
  useEffect(() => {
    if (device && !isMapInitialized) {
      // Map will be initialized by the MapContainer ref callback
    }
  }, [device, isMapInitialized]);

  // Initial fetch when vehicle ID changes
  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }

    fetchDevice(true);
  }, [id]); // Only run on ID change

  // Set up interval for background updates every 10 seconds
  useEffect(() => {
    if (!id) return;

    const intervalId = setInterval(() => {
      fetchDevice(false);
    }, 10000);

    return () => clearInterval(intervalId);
  }, [id, fetchDevice]);

  // Fetch report data when device is loaded
  useEffect(() => {
    if (device?.id) {
      fetchReportData();
      // Update report data every minute
      const interval = setInterval(fetchReportData, 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [device?.id]);

  // Fetch geofences when device changes
  useEffect(() => {
    if (device?.id) {
      fetchGeofences();
    }
  }, [device?.id]);

  // Handle vehicle selection from sidebar
  const handleVehicleSelect = (vehicleId: number) => {
    // Immediate state update for snappy feeling and to avoid loader
    const selected = devices.find((d: any) => d.id === vehicleId);
    if (selected) {
      setDevice(selected);
      setOdometer(selected?.attributes?.odometer || 0);
    }
    navigate(`/vehicle-tracking/${vehicleId}`);
  };

  // Handle floating action button clicks
  const handleMyLocation = () => {
    if (!mapInstanceRef.current) return;

    if (showingMyLocation) {
      // Switch back to vehicle location
      if (device?.latest_position?.gps_data) {
        const { latitude, longitude } = device.latest_position.gps_data;
        const vehiclePosition = {
          lat: Number(latitude),
          lng: Number(longitude),
        };
        mapInstanceRef.current.panTo(vehiclePosition);
        mapInstanceRef.current.setZoom(15);
      }

      // Remove my location marker
      if (myLocationMarkerRef.current) {
        myLocationMarkerRef.current.setMap(null);
        myLocationMarkerRef.current = null;
      }

      setShowingMyLocation(false);
    } else {
      // Show user's location
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };

            mapInstanceRef.current!.panTo(userLocation);
            mapInstanceRef.current!.setZoom(15);

            // Add or update my location marker
            if (myLocationMarkerRef.current) {
              myLocationMarkerRef.current.setPosition(userLocation);
            } else {
              myLocationMarkerRef.current = new google.maps.Marker({
                position: userLocation,
                map: mapInstanceRef.current!,
                title: "My Location",
                icon: {
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 10,
                  fillColor: "#4285F4",
                  fillOpacity: 1,
                  strokeColor: "#ffffff",
                  strokeWeight: 2,
                },
              });
            }

            setShowingMyLocation(true);
          },
          (error) => {
            console.error("Error getting user location:", error);
          }
        );
      }
    }
  };

  const handleRouteToDevice = () => {
    if (!device?.latest_position?.gps_data) return;

    const { latitude, longitude } = device.latest_position.gps_data;
    const url = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
    window.open(url, "_blank");
  };

  const handleViewOnGoogleMaps = () => {
    if (!device?.latest_position?.gps_data) return;

    const { latitude, longitude } = device.latest_position.gps_data;
    const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(url, "_blank");
  };

  const handleNearbyPlaceSelect = (placeType: string) => {
    if (!device?.latest_position?.gps_data) return;

    const { latitude, longitude } = device.latest_position.gps_data;
    const url = `https://www.google.com/maps/search/${placeType}/@${latitude},${longitude},15z`;
    window.open(url, "_blank");
    setNearbyPlacesModalOpen(false);
  };

  const timeIntervals = [
    { value: 5, label: "5 minutes" },
    { value: 10, label: "10 minutes" },
    { value: 15, label: "15 minutes" },
    { value: 60, label: "1 hour" },
    { value: 300, label: "5 hours" },
  ];

  // Compute live location URL when modal is open or parameters change
  useEffect(() => {
    if (!showLiveLocationModal) {
      setLiveLocationUrl("");
      return;
    }
    if (!device?.latest_position?.gps_data) {
      setLiveLocationUrl("");
      return;
    }

    try {
      const { latitude, longitude } = device.latest_position.gps_data;
      const userData = localStorage.getItem("user");
      let userToken = "";
      if (userData) {
        try {
          const parsedUser = JSON.parse(userData);
          userToken = parsedUser["X-AUTHORIZATION-TOKEN"] || "";
        } catch { }
      }
      const data: LiveLocationData = {
        deviceId: device.id,
        latitude,
        longitude,
        timeFrame: selectedTimeInterval,
        userToken,
        vehicleName: device.name,
        issuedAt: Date.now(),
      };
      const url = generateLiveLocationUrl(data);
      setLiveLocationUrl(url);
      // compute expiry text
      const expiryMs = getExpiryTimeMs({
        issuedAt: data.issuedAt,
        timeFrame: data.timeFrame,
      });
      const expiryDate = new Date(expiryMs);
      setLiveExpiryText(
        `Expires at ${expiryDate.toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          hour12: true,
        })}`
      );
    } catch {
      setLiveLocationUrl("");
      setLiveExpiryText("");
    }
  }, [
    showLiveLocationModal,
    selectedTimeInterval,
    device?.id,
    device?.latest_position?.gps_data?.latitude,
    device?.latest_position?.gps_data?.longitude,
  ]);

  // Update map type
  const updateMapType = (
    newMapType: "roadmap" | "satellite" | "terrain" | "hybrid"
  ) => {
    setMapType(newMapType);
    setMapTypeModalOpen(false);
  };

  // Mobilizer unlock function
  const onUnlock = async (command: string) => {
    if (!device) return;

    console.log(device?.latest_position?.protocol, command, device.id);

    try {
      const response = await axiosInstance.post(
        `/gpstracker/servermsghandler/?protocol=${device?.latest_position?.protocol}&command=${command}&device_id=${device.id}`,
        {
          protocol: device?.latest_position?.protocol,
          command: command,
          device_id: device.id,
        }
      );

      console.log(response.data);
      if (response.data?.responseData) {
        setSnackbar({
          open: true,
          message: "Command sent successfully",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error sending command:", error);
      setSnackbar({
        open: true,
        message: "Failed to send command",
        severity: "error",
      });
    }
  };

  // Modify handleMobilizerClick to check permissions
  const handleMobilizerClick = () => {
    if (!device || !canControlMobilizer || !isFeatureEnabled("immobilizer")) {
      setSnackbar({
        open: true,
        message:
          "You don't have permission to control the mobilizer or feature not available",
        severity: "error",
      });
      return;
    }

    const command = device?.latest_heartbeat?.gps_data?.terminal_info
      ?.oil_electricity_disconnected
      ? "Relay,0#"
      : "Relay,1#";

    onUnlock(command);
  };

  // Handle snackbar close
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Helper functions for statistics (based on g2.tsx logic)
  const formatTime = (hours: number): string => {
    const h = Math.floor(hours);
    const m = Math.floor((hours - h) * 60);
    return `${h}h ${m}m`;
  };

  const formatDistance = (km: number): string => {
    return `${km.toFixed(1)} KM`;
  };

  const getDeviceStatus = () => {
    if (!device) return "No Data";
    if (device.latest_heartbeat === null && device.latest_position === null)
      return "No Data";

    const lastUpdateTime = Math.max(
      device?.latest_position?.updated_at || 0,
      device?.latest_heartbeat?.updated_at || 0
    );
    const currentTime = Date.now();
    const timeDiffInHours = (currentTime - lastUpdateTime) / (1000 * 60 * 60);

    if (timeDiffInHours > 4) return "Inactive";
    if (device?.attributes?.latest_speed && device.attributes.latest_speed > 0)
      return "Running";
    if (device?.attributes?.status === "idle") return "Idle";
    if (device?.attributes?.status === "stopped") return "Stopped";
    return "No Data";
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "running":
        return "#43A047";
      case "stopped":
        return "#E53935";
      case "idle":
        return "#FFA000";
      case "inactive":
        return "#2196F3";
      default:
        return "#757575";
    }
  };

  // Helper function to get device status for sidebar
  const getDeviceStatusForSidebar = (device: Device) => {
    if (
      !device?.latest_position?.updated_at &&
      !device?.latest_heartbeat?.updated_at
    ) {
      return "No Data";
    }

    const lastUpdateTime = Math.max(
      device?.latest_position?.updated_at || 0,
      device?.latest_heartbeat?.updated_at || 0
    );
    const currentTime = Date.now();
    const timeDiffInHours = (currentTime - lastUpdateTime) / (1000 * 60 * 60);

    if (timeDiffInHours > 4) {
      return "Inactive";
    }

    if (
      device?.attributes?.latest_speed &&
      device.attributes.latest_speed > 0
    ) {
      return "Running";
    }
    if (device?.attributes?.status === "idle") {
      return "Idle";
    }
    if (device?.attributes?.status === "stopped") {
      return "Stopped";
    }
    return "No Data";
  };

  // Helper function to check if device is expired
  const oncheckExpired = (expiration_time: any) => {
    if (expiration_time) {
      const expirationTime = new Date(expiration_time).getTime();
      const currentTime = Date.now();
      return currentTime > expirationTime;
    }
    return false;
  };

  // Get device status color (matching mobile app logic)
  const getDeviceStatusColor = (deviceData: Device): string => {
    // Check for expired status first
    if (oncheckExpired(deviceData?.expiration_time)) {
      return "gray"; // Expired devices show as gray
    }

    // Check for No Data status FIRST
    if (
      !deviceData?.latest_position?.updated_at &&
      !deviceData?.latest_heartbeat?.updated_at
    ) {
      return "gray"; // No Data
    }

    // Check inactive status based on time
    const lastUpdateTime = Math.max(
      deviceData?.latest_position?.updated_at || 0,
      deviceData?.latest_heartbeat?.updated_at || 0
    );
    const currentTime = Date.now();
    const timeDiffInHours = (currentTime - lastUpdateTime) / (1000 * 60 * 60);

    if (timeDiffInHours > 4) {
      return "blue"; // Inactive
    }

    // Then check other statuses
    if (deviceData?.attributes?.latest_speed && deviceData.attributes.latest_speed > 0) {
      return "green"; // Running
    }
    if (deviceData?.attributes?.status === "idle") {
      return "yellow"; // Idle (matching mobile app - uses yellow, not orange)
    }
    if (deviceData?.attributes?.status === "stopped") {
      return "red"; // Stopped
    }

    return "gray"; // Default
  };

  // Get vehicle icon URL for sidebar
  const getVehicleIconUrlForSidebar = (deviceData: Device) => {
    const statusColor = getDeviceStatusColor(deviceData);

    // Use category icon with status color if not a car
    if (deviceData?.category && deviceData?.category.toLowerCase() !== "car") {
      return getCategoryIcon(deviceData?.category, statusColor);
    }

    // Car: use status-based colored car icons
    switch (statusColor) {
      case "blue": return "/car/blue.png";
      case "green": return "/car/green.png";
      case "yellow": return "/car/orange.png"; // Map yellow to orange for car icons
      case "red": return "/car/red.png";
      default: return "/car/white.png";
    }
  };
  const formatLastUpdatedAt = (timestamp: any) => {
    if (!timestamp) return "-";
    return format(new Date(timestamp), "dd/MM/yyyy hh:mm:ss a");
  };

  const isFeatureEnabled = (featureKey: string): boolean => {
    const port = device?.attributes?.port;
    if (!port) return false;
    return port[featureKey as keyof typeof port] === true;
  };

  // Helper function to get feature status with port check
  const getFeatureStatus = (
    featureKey: string,
    fallbackValue?: boolean
  ): boolean => {
    if (!isFeatureEnabled(featureKey)) return false;
    return fallbackValue !== undefined ? fallbackValue : true;
  };

  // Geofence functions
  const fetchGeofences = async () => {
    try {
      setIsLoadingGeofences(true);
      const response = await axiosInstance.get(
        `/gpstracker/configurationhandler/?limit=1000&offset=0&device_id=${device?.id}`,
        {}
      );
      if (response.data?.responseData) {
        const geofenceData = response.data.responseData
          .filter((config: any) => config.geofence_obj)
          .map((config: any) => {
            const geofence = config.geofence_obj;
            const areaMatch = geofence.area.match(
              /CIRCLE \(([\d.]+) ([\d.]+), ([\d.]+)\)/
            );
            let latitude = 0,
              longitude = 0,
              radius = 100;

            if (areaMatch) {
              latitude = parseFloat(areaMatch[1]);
              longitude = parseFloat(areaMatch[2]);
              radius = parseFloat(areaMatch[3]);
            }

            return {
              id: geofence.id.toString(),
              configId: config.id.toString(),
              name: geofence.name,
              latitude,
              longitude,
              radius,
              description: geofence.description,
              zone_type: geofence.attributes?.zone_type || "restricted",
              alert_radius: geofence.attributes?.alert_radius || "500m",
            };
          });
        setGeofences(geofenceData);
      }
    } catch (error) {
      console.error("Error fetching geofences:", error);
      toast.error("Failed to fetch geofences");
    } finally {
      setIsLoadingGeofences(false);
    }
  };

  const handleDeleteGeofence = async (configId: string) => {
    try {
      const response = await axiosInstance.delete(
        `/gpstracker/configurationhandler/${configId}`,
        {}
      );

      if (response.data?.responseData) {
        await fetchGeofences();
        toast.success("Geofence deleted successfully");
      }
    } catch (error) {
      toast.error("Failed to delete geofence. Please try again.");
    }
  };

  const handleAddGeofence = async () => {
    if (!newGeofence.name) {
      toast.error("Please enter a name for the geofence");
      return;
    }

    if (!device) {
      toast.error("No device selected");
      return;
    }

    setIsAddingGeofence(true);

    try {
      // Get the current map center for geofence creation
      const mapCenter = getCurrentMapCenter();

      const geofenceData = {
        name: newGeofence.name,
        description: newGeofence.description || "Geofence created from web app",
        area: `CIRCLE (${mapCenter.latitude} ${mapCenter.longitude}, ${newGeofence.radius})`,
        attributes: {
          zone_type: newGeofence.zone_type,
          alert_radius: newGeofence.alert_radius,
        },
      };

      const response = await axiosInstance.post(
        "/gpstracker/geofencehandler/",
        geofenceData
      );
      if (response.data?.responseData) {
        try {
          const user = JSON.parse(localStorage.getItem("user") || "{}");
          const configData = {
            user_id: user.id,
            device_id: device.id,
            geofence_id: response.data.responseData.id,
          };

          const configResponse = await axiosInstance.post(
            "/gpstracker/configurationhandler/",
            configData
          );

          if (configResponse.data?.responseData) {
            await fetchGeofences();
            setNewGeofence({
              name: "",
              description: "",
              radius: 100,
              zone_type: "restricted",
              alert_radius: "500m",
              latitude: 0,
              longitude: 0,
            });
            setIsCreatingGeofence(false);
            toast.success("Geofence created and configured successfully");
          }
        } catch (configError) {
          toast.warning(
            "Geofence created but configuration failed. Please try configuring it manually."
          );
        }
      }
    } catch (error) {
      toast.error("Failed to create geofence. Please try again.");
    } finally {
      setIsAddingGeofence(false);
    }
  };

  // Filter devices based on search query
  const filteredDevices = devices.filter(
    (vehicleDevice) =>
      vehicleDevice.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      vehicleDevice.unique_id.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading && !device) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          bgcolor: "#f8fafc",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#1976d2" }} />
      </Box>
    );
  }

  if (loadError) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Failed to load Google Maps: {loadError.message}
        </Alert>
        <Button
          onClick={() => navigate("/vehicles")}
          startIcon={<ArrowBackIcon />}
        >
          Back to Vehicles
        </Button>
      </Box>
    );
  }

  if (!isLoaded) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          bgcolor: "#f8fafc",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#1976d2" }} />
        <Typography sx={{ ml: 2 }}>Loading Google Maps...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button
          onClick={() => navigate("/vehicles")}
          startIcon={<ArrowBackIcon />}
        >
          Back to Vehicles
        </Button>
      </Box>
    );
  }

  if (!device) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Loading...
        </Alert>
        <Button
          onClick={() => navigate("/vehicles")}
          startIcon={<ArrowBackIcon />}
        >
          Back to Vehicles
        </Button>
      </Box>
    );
  }

  // Minimal styling
  const minimalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
    
    * {
      box-sizing: border-box;
    }
    
    body, html {
      margin: 0;
      padding: 0;
      height: 100%;
      overflow: hidden;
      position: fixed;
      width: 100%;
    }
    
    .vehicle-tracking-container {
      font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      height: 100vh;
      max-height: 100vh;
      display: flex;
      background: #f8fafc;
      position: relative;
      overflow: hidden;
      min-height: 0;
      flex-shrink: 0;
    }

    .sidebar {
      width: 260px;
      background: #ffffff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      z-index: 900;
      border-right: 1px solid #e2e8f0;
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      max-height: 100vh;
      overflow: hidden;
      min-height: 0;
    }

    .sidebar-header {
      padding: 16px;
      border-bottom: 1px solid #e2e8f0;
      background: #ffffff;
      color: #1a202c;
      flex-shrink: 0;
    }

    .sidebar-title {
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 4px 0;
      color: #1a202c;
    }

    .sidebar-subtitle {
      font-size: 12px;
      margin: 0;
      color: #718096;
    }

    .search-container {
      padding: 12px;
      border-bottom: 1px solid #e2e8f0;
      flex-shrink: 0;
    }

    .search-input {
      width: 100%;
      padding: 8px 10px 8px 32px;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      font-size: 13px;
      font-family: 'Poppins', sans-serif;
      background: #f8fafc;
      transition: all 0.2s ease;
      outline: none;
    }

    .search-input:focus {
      border-color: #4299e1;
      background: white;
      box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.1);
    }

    .search-icon {
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      color: #a0aec0;
      font-size: 14px;
    }

    .vehicles-list {
      flex: 1;
      overflow-y: auto;
      padding: 6px;
      min-height: 0;
    }

    .vehicles-list::-webkit-scrollbar {
      width: 3px;
    }

    .vehicles-list::-webkit-scrollbar-track {
      background: transparent;
    }

    .vehicles-list::-webkit-scrollbar-thumb {
      background: #e2e8f0;
      border-radius: 2px;
    }

    .vehicles-list::-webkit-scrollbar-thumb:hover {
      background: #cbd5e0;
    }

    .vehicle-item {
      display: flex;
      align-items: center;
      padding: 10px;
      margin: 2px 0;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid transparent;
    }

    .vehicle-item:hover {
      background: #f7fafc;
      border-color: #e2e8f0;
    }

    .vehicle-item.active {
      background: #4299e1;
      color: white;
      box-shadow: 0 2px 4px rgba(66, 153, 225, 0.2);
    }

    .vehicle-icon-container {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #f1f5f9;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      transition: all 0.2s ease;
    }

    .vehicle-item.active .vehicle-icon-container {
      background: rgba(255, 255, 255, 0.2);
    }

    .vehicle-icon {
      width: 16px;
      height: 16px;
    }

    .vehicle-info {
      flex: 1;
      min-width: 0;
    }

    .vehicle-name {
      font-size: 13px;
      font-weight: 500;
      margin: 0 0 2px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .vehicle-status {
      font-size: 10px;
      opacity: 0.7;
      margin: 0;
    }

    .vehicle-item.active .vehicle-status {
      opacity: 0.9;
    }

    .main-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      margin-left: 260px;
      height: 100vh;
      max-height: 100vh;
      overflow: hidden;
      min-height: 0;
    }

    .no-vehicles-message {
      padding: 24px 12px;
      text-align: center;
      color: #a0aec0;
      font-size: 13px;
    }

    /* Ensure no scrolling on the page */
    #root {
      height: 100vh;
      max-height: 100vh;
      overflow: hidden;
      position: relative;
    }
    
    /* App container */
    .App {
      height: 100vh;
      max-height: 100vh;
      overflow: hidden;
    }
    
    /* Map container specific styles */
    .map-container {
      height: calc(100vh - 64px);
      overflow: hidden;
      min-height: 0;
    }

    /* Header styles */
    .tracking-header {
      height: 48px;
      min-height: 48px;
      max-height: 48px;
      flex-shrink: 0;
      overflow: hidden;
    }

    /* Google Maps styles */
    .google-map-container {
      height: 100%;
      width: 100%;
    }

    .vehicle-marker img {
      border-radius: 50%;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .geofence-preview-marker {
      z-index: 1000;
    }

    .my-location-marker {
      z-index: 1001;
    }

    @media (max-width: 768px) {
      .sidebar {
        width: 220px;
      }
      
      .main-content {
        margin-left: 220px;
      }
      
      .sidebar-header {
        padding: 12px;
      }
      
      .sidebar-title {
        font-size: 15px;
      }
    }

    @media (max-width: 640px) {
      .sidebar {
        transform: translateX(-100%);
        transition: transform 0.3s ease;
      }
      
      .sidebar.mobile-open {
        transform: translateX(0);
      }
      
      .main-content {
        margin-left: 0;
      }
    }
  `;

  const getBatteryColor = (device: Device) => {
    const voltageLevelRaw = device?.latest_heartbeat?.gps_data?.voltage_level;
    const batteryPowerRaw = device?.latest_heartbeat?.gps_data?.battery_power;

    let percent: number | null = null;

    if (typeof voltageLevelRaw === "string") {
      const trimmed = voltageLevelRaw.trim();
      if (trimmed.endsWith("%")) {
        const numericPart = parseFloat(trimmed.slice(0, -1));
        if (!isNaN(numericPart)) {
          percent = numericPart;
        }
      }
    }

    if (percent === null) {
      const batteryNumeric = Number(batteryPowerRaw);
      if (!isNaN(batteryNumeric)) {
        percent = batteryNumeric;
      }
    }

    if (percent === null) {
      return {
        color: "#E53935",
        backgroundColor: "#FFEBEE",
      };
    }

    const isHealthy = percent > 10;
    return {
      color: isHealthy ? "#43A047" : "#E53935",
      backgroundColor: isHealthy ? "#E8F5E9" : "#FFEBEE",
    };
  };

  // Map event handlers
  const handleMapLoad = (map: google.maps.Map) => {
    mapInstanceRef.current = map;
    setIsMapInitialized(true);

    // Add click event listener for geofence creation
    map.addListener("click", (event: google.maps.MapMouseEvent) => {
      if (isCreatingGeofence && event.latLng) {
        const clickedPosition = {
          latitude: event.latLng.lat(),
          longitude: event.latLng.lng(),
        };
        setNewGeofence((prev) => ({
          ...prev,
          latitude: clickedPosition.latitude,
          longitude: clickedPosition.longitude,
        }));

        // Show preview marker
        showGeofencePreview(clickedPosition);
      }
    });
  };

  const getPowerColor = (charge: boolean) => {
    return {
      color: charge ? "#E53935" : "#43A047",
      backgroundColor: charge ? "#FFEBEE" : "#E8F5E9",
    };
  };

  const getPowerColorFromAlarmStatus = (alarmStatus?: string) => {
    if (!alarmStatus) {
      return {
        color: "#757575",
        backgroundColor: "#F5F5F5",
      };
    }
    return getPowerColor(alarmStatus === "Power Cut Alarm");
  };

  return (
    <>
      <style>{minimalStyles}</style>
      <div className="vehicle-tracking-container">
        {/* Professional Sidebar */}
        <div className="sidebar">
          {/* Sidebar Header */}
          <div className="sidebar-header">
            <h3 className="sidebar-title">Vehicle Fleet</h3>
            <p className="sidebar-subtitle">Select a vehicle to track</p>
          </div>

          {/* Search Container */}
          <div className="search-container" style={{ position: "relative" }}>
            <SearchIcon className="search-icon" />
            <input
              type="text"
              className="search-input"
              placeholder="Search vehicles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Vehicles List */}
          <div className="vehicles-list">
            {filteredDevices.length === 0 ? (
              <div className="no-vehicles-message">
                {searchQuery ? "No vehicles found" : "No vehicles available"}
              </div>
            ) : (
              filteredDevices.map((vehicleDevice) => (
                <div
                  key={vehicleDevice.id}
                  className={`vehicle-item ${device?.id === vehicleDevice.id ? "active" : ""
                    }`}
                  onClick={() => handleVehicleSelect(vehicleDevice.id)}
                  title={`Status: ${getDeviceStatusForSidebar(vehicleDevice)}`}
                >
                  <div className="vehicle-icon-container">
                    <img
                      src={getVehicleIconUrlForSidebar(vehicleDevice)}
                      alt="Vehicle"
                      className="vehicle-icon"
                    />
                  </div>
                  <div className="vehicle-info">
                    <p className="vehicle-name">{vehicleDevice.name}</p>
                    <p className="vehicle-status">
                      {getDeviceStatusForSidebar(vehicleDevice)}
                    </p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Compact Header */}
          <div
            className="tracking-header"
            style={{
              background: "#ffffff",
              color: "#1a202c",
              padding: "8px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
              borderBottom: "1px solid #e2e8f0",
              height: "48px",
              minHeight: "48px",
              maxHeight: "48px",
              flexShrink: 0,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <button
                onClick={() => navigate("/vehicles")}
                style={{
                  background: "#f7fafc",
                  border: "1px solid #e2e8f0",
                  color: "#4a5568",
                  padding: "4px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#edf2f7";
                  e.currentTarget.style.borderColor = "#cbd5e0";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#f7fafc";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
                title="Back to Vehicles"
              >
                <ArrowBackIcon style={{ fontSize: 16 }} />
              </button>
              <div>
                <h2
                  style={{
                    margin: "0",
                    fontSize: "16px",
                    fontWeight: "600",
                    fontFamily: "Poppins, sans-serif",
                    color: "#1a202c",
                  }}
                >
                  {device.name}
                </h2>
              </div>
              <div>
                <h2
                  style={{
                    margin: "0",
                    fontSize: "16px",
                    fontWeight: "300",
                    fontFamily: "Poppins, sans-serif",
                    color: "#1a202c",
                  }}
                >
                  Last Updated :{" "}
                  {device.latest_heartbeat === null
                    ? "No Data"
                    : formatLastUpdatedAt(device?.attributes?.last_updated_at)}
                </h2>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "11px",
                fontWeight: "500",
              }}
            >
              <div
                style={{
                  background: "#f7fafc",
                  color: "#4a5568",
                  padding: "2px 6px",
                  borderRadius: "3px",
                  fontSize: "10px",
                  border: "1px solid #e2e8f0",
                }}
              >
                {getDeviceStatus()}
              </div>
            </div>
          </div>

          {/* Map Container */}
          <div
            className="map-container google-map-container"
            style={{
              flex: 1,
              position: "relative",
              height: "calc(100vh - 64px)", // Subtract header height
              overflow: "hidden",
            }}
          >
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={
                device?.latest_position?.gps_data
                  ? {
                    lat: Number(device.latest_position.gps_data.latitude),
                    lng: Number(device.latest_position.gps_data.longitude),
                  }
                  : defaultCenter
              }
              zoom={15}
              options={{
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
              }}
              onLoad={handleMapLoad}
            >
              {showTraffic && <TrafficLayer />}
              {trailPath.length > 1 && (
                <Polyline
                  path={trailPath}
                  options={{
                    strokeColor: "#4285F4",
                    strokeOpacity: 0.8,
                    strokeWeight: 4,
                    geodesic: true,
                  }}
                />
              )}
              {device?.latest_position?.gps_data && (
                <Marker
                  position={{
                    lat: Number(device.latest_position.gps_data.latitude),
                    lng: Number(device.latest_position.gps_data.longitude),
                  }}
                  icon={
                    rotatedMarkerIcon || {
                      url: getVehicleIconUrl(device),
                      scaledSize: new google.maps.Size(32, 32),
                    }
                  }
                  title={device.name}
                  onClick={() => setSelectedMarker("vehicle")}
                >
                  {selectedMarker === "vehicle" && (
                    <InfoWindow onCloseClick={() => setSelectedMarker(null)}>
                      <div>
                        <h4>{device.name}</h4>
                        <p>Status: {getDeviceStatus()}</p>
                        {device?.attributes?.latest_speed && (
                          <p>Speed: {device.attributes.latest_speed} km/h</p>
                        )}
                        {device?.latest_position?.gps_data?.address && (
                          <p>
                            Address: {device.latest_position.gps_data.address}
                          </p>
                        )}
                      </div>
                    </InfoWindow>
                  )}
                </Marker>
              )}
              {geofences.map((geofence) => (
                <React.Fragment key={geofence.id}>
                  <Circle
                    center={{ lat: geofence.latitude, lng: geofence.longitude }}
                    radius={geofence.radius}
                    options={{
                      fillColor:
                        geofence.zone_type === "restricted"
                          ? "#e53e3e"
                          : "#48bb78",
                      fillOpacity: 0.2,
                      strokeColor:
                        geofence.zone_type === "restricted"
                          ? "#e53e3e"
                          : "#48bb78",
                      strokeWeight: 2,
                    }}
                  />
                  <Marker
                    position={{
                      lat: geofence.latitude,
                      lng: geofence.longitude,
                    }}
                    icon={{
                      path: google.maps.SymbolPath.CIRCLE as any,
                      scale: 0,
                      fillColor: "transparent",
                      fillOpacity: 0,
                      strokeColor: "transparent",
                      strokeWeight: 0,
                    }}
                    onClick={() => setSelectedMarker(`geofence-${geofence.id}`)}
                  >
                    {selectedMarker === `geofence-${geofence.id}` && (
                      <InfoWindow onCloseClick={() => setSelectedMarker(null)}>
                        <div>
                          <h4>{geofence.name}</h4>
                          <p>Radius: {geofence.radius}m</p>
                          <p>Type: {geofence.zone_type}</p>
                          {geofence.description && (
                            <p>{geofence.description}</p>
                          )}
                        </div>
                      </InfoWindow>
                    )}
                  </Marker>
                </React.Fragment>
              ))}
            </GoogleMap>

            {/* No GPS Data Overlay */}
            {device && !device?.latest_position?.gps_data && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1500,
                  background: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "12px",
                  padding: "32px",
                  textAlign: "center",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  backdropFilter: "blur(10px)",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                <h3
                  style={{
                    margin: "0 0 12px 0",
                    color: "#333",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  No GPS Data Available
                </h3>
                <p
                  style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  This vehicle has no location data to display on the map.
                </p>
              </div>
            )}

            {/* Floating Action Buttons - All on Right Side */}
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
                zIndex: 1000,
              }}
            >
              <Tooltip title="Toggle Traffic Layer" placement="left">
                <Fab
                  size="small"
                  onClick={() => setShowTraffic(!showTraffic)}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: showTraffic ? "#4299e1" : "white",
                    color: showTraffic ? "white" : "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: showTraffic ? "#3182ce" : "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <TrafficIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="Toggle Parking" placement="left">
                <Fab
                  size="small"
                  onClick={() => setShowParking(!showParking)}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: showParking ? "#e53e3e" : "white",
                    color: showParking ? "white" : "#718096",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: showParking ? "#c53030" : "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <ParkingIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="Change Map Type" placement="left">
                <Fab
                  size="small"
                  onClick={() => setMapTypeModalOpen(true)}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "white",
                    color: "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <MapIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="Geofencing" placement="left">
                <Fab
                  size="small"
                  onClick={() => {
                    fetchGeofences();
                    setShowGeofenceModal(true);
                  }}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "white",
                    color: "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <FenceIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip
                title={
                  showingMyLocation
                    ? "Show Vehicle Location"
                    : "Show My Location"
                }
                placement="left"
              >
                <Fab
                  size="small"
                  onClick={handleMyLocation}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: showingMyLocation ? "#4299e1" : "white",
                    color: showingMyLocation ? "white" : "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: showingMyLocation ? "#3182ce" : "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <MyLocationIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="Get Directions" placement="left">
                <Fab
                  size="small"
                  onClick={handleRouteToDevice}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "white",
                    color: "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <DirectionsIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="View on Google Maps" placement="left">
                <Fab
                  size="small"
                  onClick={handleViewOnGoogleMaps}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "white",
                    color: "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="Find Nearby Places" placement="left">
                <Fab
                  size="small"
                  onClick={() => setNearbyPlacesModalOpen(true)}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "white",
                    color: "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <LocalMallIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>

              <Tooltip title="Share Live Location" placement="left">
                <Fab
                  size="small"
                  onClick={() => setShowLiveLocationModal(true)}
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: "white",
                    color: "#4a5568",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e2e8f0",
                    "&:hover": {
                      bgcolor: "#f7fafc",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    },
                  }}
                >
                  <LiveLocationIcon sx={{ fontSize: 18 }} />
                </Fab>
              </Tooltip>
            </Box>

            {/* Redesigned Control Panel */}
            <Box
              sx={{
                position: "absolute",
                bottom: 90,
                right: 16,
                left: 16,
                zIndex: 1000,
                bgcolor: "rgba(255, 255, 255, 0.98)",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                backdropFilter: "blur(12px)",
                border: "1px solid rgba(255,255,255,0.8)",
                overflow: "hidden",
                maxWidth: "1200px",
                margin: "0 auto",
                maxHeight: "calc(100vh - 200px)", // Ensure it doesn't exceed viewport
              }}
            >
              {/* Address Section */}
              {device?.latest_position?.gps_data?.address && (
                <Box sx={{ p: 1.5, borderBottom: "1px solid #f1f5f9" }}>
                  <Typography
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      color: "#4a5568",
                      mb: 0.5,
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Current Location
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      color: "#1a202c",
                      lineHeight: 1.4,
                      fontWeight: 500,
                    }}
                  >
                    {device.latest_position.gps_data.address}
                  </Typography>
                </Box>
              )}

              {/* Main Content Grid */}
              <Box sx={{ p: 1.5 }}>
                {/* Status Icons Row */}

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(80px, 1fr))",
                    gap: 1,
                    mb: 2,
                    maxHeight: "120px", // Limit height to prevent overflow
                    overflow: "hidden",
                  }}
                >
                  {/* Current Speed */}
                  <Tooltip
                    title={`Current Speed: ${device?.attributes?.latest_speed || 0
                      } km/h`}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        p: 1,
                        border: "1px solid #e2e8f0",
                        borderRadius: 2,
                        bgcolor: "#f8fafc",
                      }}
                    >
                      <SpeedIcon
                        sx={{
                          fontSize: 18,
                          color:
                            device?.attributes?.latest_speed &&
                              device.attributes.latest_speed > 0
                              ? "#48bb78"
                              : "#718096",
                          mb: 0.5,
                        }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.65rem",
                          color: "#4a5568",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        {device?.attributes?.latest_speed
                          ? `${device.attributes.latest_speed} km/h`
                          : "0 km/h"}
                      </Typography>
                    </Box>
                  </Tooltip>

                  {/* History */}
                  <Tooltip title="View History Playback">
                    <Box
                      component="button"
                      onClick={() =>
                        navigate(`/history-playback/${device.id}`, {
                          state: { vehicleName: device.name },
                        })
                      }
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        border: "1px solid #e2e8f0",
                        background: "#f8fafc",
                        cursor: "pointer",
                        p: 1,
                        borderRadius: 2,
                        transition: "all 0.2s",
                        "&:hover": {
                          bgcolor: "#edf2f7",
                          borderColor: "#cbd5e0",
                        },
                      }}
                    >
                      <HistoryIcon
                        sx={{ fontSize: 18, color: "#4299e1", mb: 0.5 }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.65rem",
                          color: "#4a5568",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        History
                      </Typography>
                    </Box>
                  </Tooltip>

                  {/* Power */}
                  {isFeatureEnabled("power") && (() => {
                    const isNoData = getDeviceStatus() === "No Data";
                    const powerColor = isNoData
                      ? { color: "#757575", backgroundColor: "#F5F5F5" }
                      : getPowerColorFromAlarmStatus(
                        device?.latest_heartbeat?.gps_data?.terminal_info
                          ?.alarm_status
                      );
                    return (
                      <Tooltip title="Power Status">
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1,
                            border: "1px solid #e2e8f0",
                            borderRadius: 2,
                            bgcolor: "#f8fafc",
                          }}
                        >
                          <PowerIcon
                            sx={{
                              fontSize: 18,
                              color: powerColor.color,
                              mb: 0.5,
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.65rem",
                              color: powerColor.color,
                              fontWeight: 500,
                              textAlign: "center",
                            }}
                          >
                            Power
                          </Typography>
                        </Box>
                      </Tooltip>
                    );
                  })()}

                  {/* Ignition */}
                  {isFeatureEnabled("ignition") && (() => {
                    const isNoData = getDeviceStatus() === "No Data";
                    const ignitionColor = isNoData
                      ? "#757575"
                      : getFeatureStatus(
                        "ignition",
                        device?.attributes?.ignition
                      )
                        ? "#48bb78"
                        : "#e53e3e";
                    return (
                      <Tooltip
                        title={
                          getFeatureStatus(
                            "ignition",
                            device?.attributes?.ignition
                          )
                            ? "Ignition On"
                            : "Ignition Off"
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1,
                            border: "1px solid #e2e8f0",
                            borderRadius: 2,
                            bgcolor: "#f8fafc",
                          }}
                        >
                          <KeyIcon
                            sx={{
                              fontSize: 18,
                              color: ignitionColor,
                              mb: 0.5,
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.65rem",
                              color: "#4a5568",
                              fontWeight: 500,
                              textAlign: "center",
                            }}
                          >
                            Ignition
                          </Typography>
                        </Box>
                      </Tooltip>
                    );
                  })()}

                  {/* GPS */}
                  {(() => {
                    const isNoData = getDeviceStatus() === "No Data";
                    const gpsColor = isNoData
                      ? "#757575"
                      : device?.latest_heartbeat
                        ? "#48bb78"
                        : "#e53e3e";
                    return (
                      <Tooltip
                        title={
                          device?.latest_heartbeat
                            ? "GPS Connected"
                            : "GPS Disconnected"
                        }
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1,
                            border: "1px solid #e2e8f0",
                            borderRadius: 2,
                            bgcolor: "#f8fafc",
                          }}
                        >
                          <WifiIcon
                            sx={{
                              fontSize: 18,
                              color: gpsColor,
                              mb: 0.5,
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.65rem",
                              color: "#4a5568",
                              fontWeight: 500,
                              textAlign: "center",
                            }}
                          >
                            GPS
                          </Typography>
                        </Box>
                      </Tooltip>
                    );
                  })()}

                  {/* Battery */}
                  {isFeatureEnabled("externalBattery") && (() => {
                    const isNoData = getDeviceStatus() === "No Data";
                    const batteryColor = isNoData
                      ? "#757575"
                      : getFeatureStatus(
                        "externalBattery",
                        !!device?.latest_heartbeat?.gps_data
                          ?.external_voltage_value
                      )
                        ? "#48bb78"
                        : "#e53e3e";
                    return (
                      <Tooltip
                        title={`Battery: ${device?.latest_heartbeat?.gps_data
                          ?.external_voltage_value || 0
                          }V`}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1,
                            border: "1px solid #e2e8f0",
                            borderRadius: 2,
                            bgcolor: "#f8fafc",
                          }}
                        >
                          <BatteryIcon
                            sx={{
                              fontSize: 18,
                              color: batteryColor,
                              mb: 0.5,
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.6rem",
                              color: "#4a5568",
                              fontWeight: 500,
                              textAlign: "center",
                            }}
                          >
                            {device?.latest_heartbeat?.gps_data
                              ?.external_voltage_value
                              ? `${device.latest_heartbeat.gps_data.external_voltage_value}V`
                              : "0V"}
                          </Typography>
                        </Box>
                      </Tooltip>
                    );
                  })()}

                  {isFeatureEnabled("internalBattery") && (() => {
                    const isNoData = getDeviceStatus() === "No Data";
                    const batteryColor = isNoData
                      ? { color: "#757575", backgroundColor: "#F5F5F5" }
                      : getBatteryColor(device);
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #e2e8f0",
                          borderRadius: 2,
                          bgcolor: "#f8fafc",
                        }}
                      >
                        <BatteryIcon
                          sx={{
                            fontSize: 18,
                            color: batteryColor.color,
                            mb: 0.5,
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            color: "#4a5568",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          {typeof device?.latest_heartbeat?.gps_data
                            ?.voltage_level === "string" &&
                            device?.latest_heartbeat?.gps_data?.voltage_level
                              .trim()
                              .endsWith("%")
                            ? device?.latest_heartbeat?.gps_data?.voltage_level.trim()
                            : `${(device?.latest_heartbeat?.gps_data
                              ?.voltage_level ||
                              device?.latest_heartbeat?.gps_data
                                ?.battery_power) ??
                            0
                            }%`}
                        </Typography>
                      </Box>
                    );
                  })()}

                  {/* Mobilizer */}
                  {canControlMobilizer && isFeatureEnabled("immobilizer") && (() => {
                    const isNoData = getDeviceStatus() === "No Data";
                    const lockColor = isNoData
                      ? "#757575"
                      : getFeatureStatus(
                        "immobilizer",
                        !device?.latest_heartbeat?.gps_data?.terminal_info
                          ?.oil_electricity_disconnected
                      )
                        ? "#48bb78"
                        : "#e53e3e";
                    return (
                      <Tooltip
                        title={
                          device?.latest_heartbeat?.gps_data?.terminal_info
                            ?.oil_electricity_disconnected
                            ? "Enable Mobilizer"
                            : "Disable Mobilizer"
                        }
                      >
                        <Box
                          component="button"
                          onClick={handleMobilizerClick}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            p: 1,
                            border: "1px solid #e2e8f0",
                            borderRadius: 2,
                            bgcolor: "#f8fafc",
                            cursor: "pointer",
                            "&:hover": {
                              bgcolor: "#edf2f7",
                              borderColor: "#cbd5e0",
                            },
                          }}
                        >
                          <LockIcon
                            sx={{
                              fontSize: 18,
                              color: lockColor,
                              mb: 0.5,
                            }}
                          />
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.65rem",
                              color: "#4a5568",
                              fontWeight: 500,
                              textAlign: "center",
                            }}
                          >
                            Mobilizer
                          </Typography>
                        </Box>
                      </Tooltip>
                    );
                  })()}

                  {/* Share */}
                  <Tooltip title="Share Vehicle Location">
                    <Box
                      component="button"
                      onClick={() => {
                        if (device?.latest_position?.gps_data) {
                          const { latitude, longitude } =
                            device.latest_position.gps_data;
                          const url = `https://maps.google.com/?q=${latitude},${longitude}`;
                          navigator
                            .share?.({
                              title: `${device.name} Location`,
                              text: `Current location of ${device.name}`,
                              url: url,
                            })
                            .catch(() => {
                              navigator.clipboard.writeText(url);
                              alert("Location link copied to clipboard!");
                            });
                        }
                      }}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        p: 1,
                        border: "1px solid #e2e8f0",
                        borderRadius: 2,
                        bgcolor: "#f8fafc",
                        cursor: "pointer",
                        "&:hover": {
                          bgcolor: "#edf2f7",
                          borderColor: "#cbd5e0",
                        },
                      }}
                    >
                      <ShareIcon
                        sx={{ fontSize: 18, color: "#4299e1", mb: 0.5 }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.65rem",
                          color: "#4a5568",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        Share
                      </Typography>
                    </Box>
                  </Tooltip>

                  {/* AC Control */}
                  {isFeatureEnabled("ac") && (
                    <Tooltip
                      title={
                        getFeatureStatus("ac", device?.attributes?.ac)
                          ? "AC On"
                          : "AC Off"
                      }
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #e2e8f0",
                          borderRadius: 2,
                          bgcolor: "#f8fafc",
                        }}
                      >
                        <AcIcon
                          sx={{
                            fontSize: 18,
                            color: getFeatureStatus(
                              "ac",
                              device?.attributes?.ac
                            )
                              ? "#4299e1"
                              : "#718096",
                            mb: 0.5,
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            color: "#4a5568",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          AC
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}

                  {/* Fuel */}
                  {isFeatureEnabled("fuel") && (
                    <Tooltip title="Fuel Monitoring">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #e2e8f0",
                          borderRadius: 2,
                          bgcolor: "#f8fafc",
                        }}
                      >
                        <FuelIcon
                          sx={{
                            fontSize: 18,
                            color: "#f6ad55",
                            mb: 0.5,
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            color: "#4a5568",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Fuel
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}

                  {/* Driver */}
                  <Tooltip title="Driver Information">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        p: 1,
                        border: "1px solid #e2e8f0",
                        borderRadius: 2,
                        bgcolor: "#f8fafc",
                      }}
                    >
                      <DriverIcon
                        sx={{
                          fontSize: 18,
                          color: "#9f7aea",
                          mb: 0.5,
                        }}
                      />
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.65rem",
                          color: "#4a5568",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        Driver
                      </Typography>
                    </Box>
                  </Tooltip>

                  {/* Temperature */}
                  {isFeatureEnabled("temp") && (
                    <Tooltip title="Temperature Monitoring">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #e2e8f0",
                          borderRadius: 2,
                          bgcolor: "#f8fafc",
                        }}
                      >
                        <TempIcon
                          sx={{
                            fontSize: 18,
                            color: "#e53e3e",
                            mb: 0.5,
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            color: "#4a5568",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Temp
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}

                  {/* Door */}
                  {isFeatureEnabled("door") && (
                    <Tooltip title="Door Status">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          p: 1,
                          border: "1px solid #e2e8f0",
                          borderRadius: 2,
                          bgcolor: "#f8fafc",
                        }}
                      >
                        <DoorSlidingIcon
                          sx={{
                            fontSize: 18,
                            color: "#38a169",
                            mb: 0.5,
                          }}
                        />
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.65rem",
                            color: "#4a5568",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          Door
                        </Typography>
                      </Box>
                    </Tooltip>
                  )}
                </Box>

                {/* Statistics Section */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                    gap: 1,
                    maxHeight: "80px", // Limit height to prevent overflow
                    overflow: "hidden",
                  }}
                >
                  {/* Today Distance */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      transition: "all 0.2s",
                      border: "1px solid #e2e8f0",
                      "&:hover": {
                        bgcolor: "#f1f5f9",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        borderRadius: 1,
                        bgcolor: "#4299e1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: 0.5,
                        transition: "all 0.2s",
                      }}
                    >
                      <CarIcon sx={{ fontSize: 12, color: "white" }} />
                    </Box>
                    <Box>
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.55rem",
                          color: "#718096",
                          display: "block",
                          lineHeight: 1,
                          fontWeight: 500,
                        }}
                      >
                        Today Distance
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#4299e1",
                          mt: 0.25,
                          lineHeight: 1,
                        }}
                      >
                        {reportData?.total_distance
                          ? formatDistance(reportData.total_distance)
                          : "0.0 KM"}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Ignition Hours */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <KeyIcon sx={{ fontSize: 14, color: "#48bb78", mr: 0.5 }} />
                    <Box>
                      <Typography
                        sx={{ fontSize: "0.55rem", color: "#718096" }}
                      >
                        Ignition Hours
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#48bb78",
                        }}
                      >
                        {reportData?.ignition_hours}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Running Time */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <TimerIcon
                      sx={{ fontSize: 14, color: "#38a169", mr: 0.5 }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontSize: "0.55rem", color: "#718096" }}
                      >
                        Running Time
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#38a169",
                        }}
                      >
                        {reportData?.running_time}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Inactive Time */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <PauseIcon
                      sx={{ fontSize: 14, color: "#4299e1", mr: 0.5 }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontSize: "0.55rem", color: "#718096" }}
                      >
                        Inactive Time
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#4299e1",
                        }}
                      >
                        {reportData?.inactive_time}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Idle Time */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <PauseIcon
                      sx={{ fontSize: 14, color: "#ed8936", mr: 0.5 }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontSize: "0.55rem", color: "#718096" }}
                      >
                        Idle Time
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#ed8936",
                        }}
                      >
                        {reportData?.idle_time}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Total Odometer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <SpeedIcon
                      sx={{ fontSize: 14, color: "#4a5568", mr: 0.5 }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontSize: "0.55rem", color: "#718096" }}
                      >
                        Total Odometer
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#4a5568",
                        }}
                      >
                        {odometer?.toFixed(0) || 0} KM
                      </Typography>
                    </Box>
                  </Box>

                  {/* Stop Time */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      p: 0.5,
                      bgcolor: "#f8fafc",
                      borderRadius: 1,
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <StopIcon
                      sx={{ fontSize: 14, color: "#e53e3e", mr: 0.5 }}
                    />
                    <Box>
                      <Typography
                        sx={{ fontSize: "0.55rem", color: "#718096" }}
                      >
                        Stop Time
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          color: "#e53e3e",
                        }}
                      >
                        {reportData?.stop_time}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
        </div>
      </div>

      {/* Map Type Modal */}
      <Dialog
        open={mapTypeModalOpen}
        onClose={() => setMapTypeModalOpen(false)}
      >
        <DialogTitle>Select Map Type</DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 2 }}>
          <FormControl fullWidth sx={{ mt: 1 }}>
            <InputLabel>Map Type</InputLabel>
            <Select
              value={mapType}
              label="Map Type"
              onChange={(e) => updateMapType(e.target.value as any)}
            >
              <MenuItem value="roadmap">Standard</MenuItem>
              <MenuItem value="satellite">Satellite</MenuItem>
              <MenuItem value="terrain">Terrain</MenuItem>
              <MenuItem value="hybrid">Hybrid</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setMapTypeModalOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Nearby Places Modal */}
      <Dialog
        open={nearbyPlacesModalOpen}
        onClose={() => setNearbyPlacesModalOpen(false)}
      >
        <DialogTitle>Nearby Places</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              minWidth: 250,
            }}
          >
            <Button
              variant="outlined"
              onClick={() => handleNearbyPlaceSelect("restaurant")}
              sx={{ justifyContent: "flex-start" }}
            >
              Restaurants
            </Button>
            <Button
              variant="outlined"
              onClick={() => handleNearbyPlaceSelect("hospital")}
              sx={{ justifyContent: "flex-start" }}
            >
              Hospitals
            </Button>
            <Button
              variant="outlined"
              onClick={() => handleNearbyPlaceSelect("police")}
              sx={{ justifyContent: "flex-start" }}
            >
              Police Stations
            </Button>
            <Button
              variant="outlined"
              onClick={() => handleNearbyPlaceSelect("gas_station")}
              sx={{ justifyContent: "flex-start" }}
            >
              Gas Stations
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNearbyPlacesModalOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Geofence Modal */}
      <Dialog
        open={showGeofenceModal}
        onClose={() => setShowGeofenceModal(false)}
        aria-labelledby="geofence-modal-title"
      >
        <DialogTitle>Geofence Configuration</DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 2 }}>
          <Box sx={{ mt: 2 }}>
            <Typography variant="h6" component="h2" gutterBottom>
              {isCreatingGeofence ? "Create New Geofence" : "Geofences"}
            </Typography>

            {isCreatingGeofence ? (
              <Box component="form" sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Name"
                  value={newGeofence.name}
                  onChange={(e) =>
                    setNewGeofence({ ...newGeofence, name: e.target.value })
                  }
                  margin="normal"
                  required
                />
                <TextField
                  fullWidth
                  label="Description"
                  value={newGeofence.description}
                  onChange={(e) =>
                    setNewGeofence({
                      ...newGeofence,
                      description: e.target.value,
                    })
                  }
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="Radius (meters)"
                  type="number"
                  value={newGeofence.radius}
                  onChange={(e) =>
                    setNewGeofence({
                      ...newGeofence,
                      radius: Number(e.target.value),
                    })
                  }
                  margin="normal"
                  required
                />
                <FormControl fullWidth margin="normal">
                  <InputLabel>Zone Type</InputLabel>
                  <Select
                    value={newGeofence.zone_type}
                    onChange={(e) =>
                      setNewGeofence({
                        ...newGeofence,
                        zone_type: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="restricted">Restricted</MenuItem>
                    <MenuItem value="allowed">Allowed</MenuItem>
                  </Select>
                </FormControl>
                <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                  <Button
                    variant="outlined"
                    onClick={() => setIsCreatingGeofence(false)}
                    disabled={isAddingGeofence}
                  >
                    Cancel
                  </Button>
                  {/* Assuming LoadingButton is a custom component or MUI component */}
                  {/* If not, replace with a standard Button or MUI Button with loading prop */}
                  <Button
                    variant="contained"
                    onClick={handleAddGeofence}
                    disabled={isAddingGeofence}
                  >
                    {isAddingGeofence ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Add Geofence"
                    )}
                  </Button>
                </Box>
              </Box>
            ) : (
              <>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => setIsCreatingGeofence(true)}
                  sx={{ mb: 2 }}
                >
                  Add New Geofence
                </Button>

                {isLoadingGeofences ? (
                  <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                    <CircularProgress />
                  </Box>
                ) : geofences.length === 0 ? (
                  <Typography
                    color="text.secondary"
                    align="center"
                    sx={{ p: 3 }}
                  >
                    No geofences configured
                  </Typography>
                ) : (
                  <List>
                    {geofences.map((fence) => (
                      <ListItem
                        key={fence.id}
                        secondaryAction={
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => handleDeleteGeofence(fence.configId)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        }
                      >
                        <ListItemText
                          primary={fence.name}
                          secondary={
                            <>
                              <Typography
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                                Radius: {fence.radius}m
                              </Typography>
                              {fence.description && (
                                <Typography
                                  component="p"
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {fence.description}
                                </Typography>
                              )}
                            </>
                          }
                        />
                        <Chip
                          label={fence.zone_type}
                          color={
                            fence.zone_type === "restricted"
                              ? "error"
                              : "success"
                          }
                          size="small"
                          sx={{ ml: 1 }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowGeofenceModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Live Location Modal */}
      <Dialog
        open={showLiveLocationModal}
        onClose={() => setShowLiveLocationModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <LiveLocationIcon sx={{ color: "#4299e1" }} />
            Share Live Location
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pt: 1, pb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Share the current location of <strong>{device?.name}</strong> with
            others for a specific duration.
          </Typography>

          <FormControl fullWidth sx={{ mb: 3 }}>
            <InputLabel>Duration</InputLabel>
            <Select
              value={selectedTimeInterval}
              label="Duration"
              onChange={(e) => setSelectedTimeInterval(Number(e.target.value))}
            >
              {timeIntervals.map((interval) => (
                <MenuItem key={interval.value} value={interval.value}>
                  {interval.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            label="Live location URL"
            value={liveLocationUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="copy live location url"
                    onClick={() => {
                      if (!liveLocationUrl) return;
                      navigator.clipboard.writeText(liveLocationUrl);
                      setSnackbar({
                        open: true,
                        message: "Live location link copied to clipboard!",
                        severity: "success",
                      });
                    }}
                  >
                    <CopyIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {liveExpiryText && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 1, display: "block" }}
            >
              {liveExpiryText}
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={() => setShowLiveLocationModal(false)}
            sx={{ mr: 1 }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default VehicleTracking;
